<template>
  <div>
    <!-- hide only on large scroeen  -->
    <v-toolbar dense flat class="top-nav white--text d-lg-none">
      <v-app-bar-nav-icon @click.native="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="text-weight-400 dashboard--title">
        CBDRTBC Dashboard
      </v-toolbar-title>
    </v-toolbar>
    <!-- / -->

    <v-navigation-drawer v-model="drawer" app>
      <v-sheet
        color="purple accent-4"
        class="d-flex flex-column justify-center pa-4"
      >
        <div class="white--text project--title text-uppercase text-center pb-1">
          CBDRTBC Project
        </div>
        <div class="py-2 pr-2">
          <v-img
            contain
            src="./../../assets/static-images/title.svg"
            aspect-ratio="3.9"
          />
        </div>
      </v-sheet>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item to="/">
          <v-list-item-icon>
            <v-icon> mdi-home-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/volunteer/townships">
          <v-list-item-icon>
            <v-icon> mdi-account-heart-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Volunteers</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/patient/townships">
          <v-list-item-icon>
            <v-icon> mdi-account-box-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Patients</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/presumptive/townships">
          <v-list-item-icon>
            <v-icon> mdi-book-arrow-right-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Presumptive Register</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/activity/townships">
          <v-list-item-icon>
            <v-icon> mdi-charity</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Activity</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/ci/townships">
          <v-list-item-icon>
            <v-icon> mdi-account-box-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>CI/HE</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/report">
          <v-list-item-icon>
            <v-icon>mdi-clipboard-file-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Report</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Export lists Group -->
        <v-list-group prepend-icon="mdi-printer">
          <template v-slot:activator>
            <v-list-item-title>Exports</v-list-item-title>
          </template>

          <v-list-item to="/export/ci">
            <v-list-item-icon>
              <v-icon>mdi-file-export-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>CI/HE Export</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/export/familymember-export">
            <v-list-item-icon>
              <v-icon> mdi-account-group-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Family Member Export</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/export/outcome-export">
            <v-list-item-icon>
              <v-icon> mdi-file-table-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Outcome Export</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/export/presumptive">
            <v-list-item-icon>
              <v-icon>mdi-file-export-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Presumptive Export</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/export/patient-enroll">
            <v-list-item-icon>
              <v-icon>mdi-file-export-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Enroll Patient Export</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/export/dots-patient-export">
            <v-list-item-icon>
              <v-icon>mdi-file-export-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>DOT Patient Export</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/export/complementary-export">
            <v-list-item-icon>
              <v-icon>mdi-file-export-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Complementary Export</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <br><br>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  computed: {},
  data: () => ({
    drawer: true,
  }),
};
</script>

<style scoped>
.project--title {
  letter-spacing: 3px;
  font-weight: 300 !important;
}
.v-list .v-list-item--active {
  color: var(--primary-color);
}
.v-list-group .v-list-group--active {
  color: grey !important;
}
.top-nav {
  box-shadow: var(--primary-box-shadow) !important;
  background-image: linear-gradient(
    to top,
    #aa00ff,
    #ad10fd,
    #af1bfc,
    #b223fa,
    #b42af9
  );
}
.v-toolbar__title {
  cursor: pointer;
}
.dashboard--title {
  font-weight: 300 !important;
  letter-spacing: 2px;
  font-size: 17px;
}
</style>
